<template>
  <div class="oversea-billing">
    <cargo-up-down-resize
      class="section"
      :up-style="{display: 'flex', flexDirection: 'column', paddingBottom: '5px'}"
      :down-style="{display: 'flex', flexDirection: 'column', paddingTop: '5px'}"
      style="height: 100%"
    >
      <template slot="up">
        <div class=" operations">
          <div class="triggers">
            <div>
              <span v-show="controllerVisible.showSpecialCharge" style="color:#404144;margin-right:5px">{{ $t('FinanceManage.domestic_billingBranchId') }}</span>
              <el-select
                v-show="controllerVisible.showSpecialCharge"
                v-model="specialBillingBranchId"
                :disabled="!readonly"
                :splaceholder="$t('Message.PleaseSelect')"
                :clearable="false"
                size="mini"
                style="margin-right: 5px"
                @change="p=>{ pm.onBillingBranchIdHandler(p)}"
              >
                <el-option
                  v-for="(item,index) in officeList"
                  :key="index"
                  :label="item.chineseName"
                  :value="item.officeId"
                />
              </el-select>
              <el-checkbox
                v-show="masterFlag"
                v-model="cbShowAllBilling"
                no="showAllBilling"
                style="margin-right: 5px"
                @change="pm.showAllBillingChangeHandler()"
              >{{ $t('FinanceManage.international_showAllBilling') }}</el-checkbox>
              <el-checkbox
                v-show="controllerVisible.cbShowSelfChanges"
                v-model="cbShowSelfChanges"
                no="commissionedChargesOnly"
                style="margin-right: 5px"
                @change="pm.showSelfChargeChangeHandler()"
              >{{ $t('FinanceManage.international_commissionedChargesOnly') }}</el-checkbox>
              <el-checkbox
                v-show="controllerVisible.cbShowInternal"
                v-model="cbShowInternal"
                no="domestic_showInternal"
                style="margin-right: 5px"
                @change="pm.showInternalChargeHandler()"
              >{{ this.$t('CargoMsg.Cargo_ShowInternalCharges') }}</el-checkbox>
            </div>
            <cargo-button-group-slider align="right" style="flex:1; border: none">
              <div>
                <!-- 指令操作按钮 -->
                <template v-for="(item, index) in instructioinBtns">
                  <el-button
                    :key="index"
                    :no="item.platformInstructionRuleCode"
                    type="primary"
                    :disabled="item.platformInstructionRuleCode === 'overseaBillEdit' ? !item.allowOperate || !btnEnable.btnEdit : !item.allowOperate"
                    @click="onInstructionClick(item)"
                  >
                    {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
                  </el-button>
                </template>
                <el-button v-if="!billPageSet.newHide" no="international_add" type="primary" :disabled="!btnEnable.btnAdd" @click="pm.onAddClickEvent()">{{ $t('FinanceManage.international_add') }}</el-button>
                <el-button v-if="!billPageSet.editHide" no="btnEdit" type="primary" :disabled="!btnEnable.btnEdit" @click="pm.onEditClickEvent()">{{ $t('FinanceManage.international_edit') }}</el-button>
                <!--删除-->
                <el-button v-show="permission.btnDel" no="btnDel" type="danger" :disabled="selectedDataList.length > 0 ? false : !btnEnable.btnDel" @click="pm.onDelClickEvent()">{{ $t('FinanceManage.international_delete') }}</el-button>
                <el-button type="primary" :disabled="isEdit||!selectedBilling||selectedBilling.billingType==='代理分成账单'" @click="viewClickHandler">{{ this.$t('FinanceManage.domestic_view') }}</el-button>
                <!--审核-->
                <el-button v-show="permission.btnAutid && viewSource!=='salesDetail'" no="btnAutid" type="primary" :disabled="!btnEnable.btnAutid" @click="pm.onAutidClickEvent()">{{ $t('FinanceManage.international_audit') }}</el-button>
                <!--作废-->
                <el-button v-show="permission.btnInvalid" no="btnInvalid" type="primary" :disabled="!btnEnable.btnInvalid" @click="pm.onInvaidClickEvent()">{{ $t('FinanceManage.international_invalid') }}</el-button>
                <!--代理分成账单-->
                <el-button v-show="viewSource!=='salesDetail'" no="btnAgent" :disabled="!btnEnable.btnAgent" type="primary" @click="pm.onAgentClickEvent()">{{ $t('FinanceManage.international_agentProfitShareBillNo') }}</el-button>
                <!--打印所有代理分成账单-->
                <el-button v-show="controllerVisible.btnPrintAllAgent" no="btnPrintAllAgent" type="primary" @click="pm.onPrintAllAgentClickEvent()">{{ $t('FinanceManage.international_printAllAgentProfitShareBillNo') }}</el-button>
                <!--编辑对方账单号-->
                <el-button v-show="permission.btnEditAgentBillNo" no="btnEditAgentBillNo" type="primary" :disabled="!btnEnable.btnEditAgentBillNo" @click="pm.onEditAgentBillNoClickEvent()">{{ $t('FinanceManage.international_editAgentBillNo') }}</el-button>
                <!--确认-->
                <el-button v-show="$checkPermission(['button_Billing_overseaBillingConfrim'])" no="overseaBillingConfrim" type="primary" :disabled="selectedDataList.length > 0 ? false : !btnEnable.btnConfirm" @click="btnConfrimClickHandle">{{ $t('FinanceManage.domestic_confirm') }}</el-button>
                <!--取消确认-->
                <el-button v-show="$checkPermission(['button_Billing_overseaBillingCancelConfrim'])" no="overseaBillingCancelConfrim" type="primary" :disabled="selectedDataList.length > 0 ? false : !btnEnable.btnCancelConfirm" @click="pm.btnCancelConfrimHandler()">{{ $t('FinanceManage.domestic_cancelConfirm') }}</el-button>
                <!--复核-->
                <el-tooltip type="primary" :content="$t('Billing.billing_recheckTip')" placement="bottom">
                  <el-button v-permission="['button_billTab_overseaBillingRecheck']" style="margin-left: 5px;" no="recheck" type="primary" :disabled="!btnEnable.btnRecheck" @click="btnRecheckClickHandle">{{ this.$t('Billing.billing_recheck') }}</el-button>
                </el-tooltip>
                <!--取消复核-->
                <el-button v-permission="['button_billTab_overseaBillingCancelRecheck']" no="cancelRecheck" type="primary" :disabled="!btnEnable.btnCancelRecheck" @click="pm.btnCancelRecheckBillingHandler()">{{ this.$t('Billing.billing_cancelRecheck') }}</el-button>
                <!--强制删除-->
                <el-button v-show="$checkPermission(['button_billTab_forceDelete'])" no="forceDelete" type="danger" :disabled="selectedDataList.length > 0 ? false : isEdit && !pm.isOcPaymentLock" @click="pm.forceDeleteHandler()">{{ $t('CargoMsg.Cargo_ForceDelete') }}</el-button>
                <!--申请付款-->
                <el-button v-show="$checkPermission(['button_billTab_payauthFromBilling'])" no="payauthFromBillin" type="primary" :disabled="isEdit||up.selectedRows.length===0" @click="applyForPayment">{{ $t('Billing.billing_applyForPayment') }}</el-button>
              </div>
            </cargo-button-group-slider>
          </div>
        </div>
        <cargo-ag-grid
          no="130126"
          config-module="130126"
          :grid-options="up.gridOptions"
          :grid-params.sync="up.gridParams"
          :column-defs="upColumnDefs"
          :row-data="billingList"
          style="flex-grow:1;margin-top:10px;"
          @gridReady="params=>up.gridApi=params.api"
        />
      </template>
      <template slot="down">
        <cargo-ag-grid
          no="130127"
          config-module="130127"
          :grid-options="down.gridOptions"
          :grid-params.sync="down.gridParams"
          :column-defs="downColumnDefs"
          :row-data="chargeList"
          style="flex:1;margin:10px 0px;"
          @gridReady="params=>down.gridApi=params.api"
        />
      </template>
    </cargo-up-down-resize>

    <!--国外账单详情页-->
    <oversea-billing-dialog
      v-if="overseaBillingDialog.visible"
      ref="overseaBillingDialog"
      :visible.sync="overseaBillingDialog.visible"
      :job="overseaBillingDialog.job"
      :prop-billing="overseaBillingDialog.propBilling"
      :is-add-or-edit="overseaBillingDialog.isAddOrEdit"
      :debit-chargetax-rate="overseaBillingDialog.debitChargetaxRate"
      :prop-billing-charge-accounts="overseaBillingDialog.billingChargeAccounts"
      :billing-charge-detail="overseaBillingDialog.billingChargeDetail"
      :current-billing-branch-id="overseaBillingDialog.currentBillingBranchId"
      :department-team-user="overseaBillingDialog.departmentTeamUser"
      :create-bill-way="overseaBillingDialog.createBillWay"
      :create-oversea-charge="createOverseaCharge"
      :location="location"
      :show-wht-tax="showWhtTax"
      :instruction-btns="overseaBillingDialog.instructionBtns"
      @applyInvoice="bill=>{toMakeInvoice(bill,()=>{overseaBillingDialog.visible=false})}"
      @onCloseCallBackFun="onCloseCallBackFun"
    />

    <!--国外账单详情页-->
    <split-oversea-billing-dialog
      v-if="newOverseaBillingDialog.visible"
      ref="overseaBillingDialog"
      :visible.sync="newOverseaBillingDialog.visible"
      :job="overseaBillingDialog.job"
      :prop-billing="overseaBillingDialog.propBilling"
      :is-add-or-edit="overseaBillingDialog.isAddOrEdit"
      :debit-chargetax-rate="overseaBillingDialog.debitChargetaxRate"
      :prop-billing-charge-accounts="overseaBillingDialog.billingChargeAccounts"
      :billing-charge-detail="overseaBillingDialog.billingChargeDetail"
      :current-billing-branch-id="overseaBillingDialog.currentBillingBranchId"
      :department-team-user="overseaBillingDialog.departmentTeamUser"
      :customer-detail="newOverseaBillingDialog.customerDetail"
      :create-bill-way="overseaBillingDialog.createBillWay"
      :create-oversea-charge="createOverseaCharge"
      :location="location"
      :show-wht-tax="showWhtTax"
      :instruction-btns="overseaBillingDialog.instructionBtns"
      @applyInvoice="bill=>{toMakeInvoice(bill,()=>{newOverseaBillingDialog.visible=false})}"
      @viewInvoice="invoiceUuids=>{newOverseaBillingDialog.visible=false; $refs.invoice.openInvoiceDetails(invoiceUuids)}"
      @onCloseCallBackFun="onCloseCallBackFun"
    />
    <!--编辑代理账单编号-->
    <edit-agent-bill-no-dialog
      v-if="editAgentBillNoDialog.visible"
      :visible.sync="editAgentBillNoDialog.visible"
      :billing="selectedBilling"
      @editAgentBillNoSaveSuccessHandler="editAgentBillNoSaveSuccessHandler"
    />

    <!-- 代理分成账单弹窗 -->
    <agency-share-bill-dialog
      v-if="agencyShareBillDialog.visible"
      :visible.sync="agencyShareBillDialog.visible"
      :prop-billing="agencyShareBillDialog.propBilling"
      :job="agencyShareBillDialog.job"
      :current-billing-branch-id="agencyShareBillDialog.currentBillingBranchId"
      :view-source="viewSource"
      :location="location"
      @agentSaveSuccessHandler="agentSaveSuccessHandler"
    />

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      ref="templateDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!--申请付款-->
    <bill-payment-dialog
      ref="billPayment"
      :open-sap-config="false"
      :visible.sync="showBillPaymentDialog"
      :create-submit="true"
      step="step2"
      source="append"
      :bill-payment-uuid="billPaymentDialogUuid"
      :job="job"
      :location="location"
      @cancel="cancel"
      @toPreStepForBusiness="p=>{this.showBillPaymentDialog=false;toPreStep()}"
    />
    <!-- 付款申请-H5（客户化版本）-->
    <new-bill-payment-dialog
      :visible="billPaymentDialogForH5.visible"
      :title="billPaymentDialogForH5.title"
      :bill-payment-account-id="billPaymentDialogForH5.defaultConditions.accountId"
      :view-source="billPaymentDialogForH5.source"
      :bill-payment-uuid="billPaymentDialogForH5.uuid"
      :default-conditions="billPaymentDialogForH5.defaultConditions"
      @close="billPaymentDialogForH5.visible=false"
    />
    <!--付款申请-H5（详情)-->
    <bill-payment-detail-for-h5
      v-if="billPaymentDialogForH5.billPaymentDetailProperties.visible"
      ref="billPaymentDetailForH5"
      :bill-payment-uuid="billPaymentDialogForH5.billPaymentDetailProperties.uuid"
      :title="billPaymentDialogForH5.billPaymentDetailProperties.title"
      :visible.sync="billPaymentDialogForH5.billPaymentDetailProperties.visible"
      :state="billPaymentDialogForH5.billPaymentDetailProperties.state"
      :charges="billPaymentDialogForH5.billPaymentDetailProperties.charges"
      :charges-dirty="true"
      :bill-payment-dirty="true"
      :open-sap-config="false"
      :input-by="billPaymentDialogForH5.billPaymentDetailProperties.inputBy"
      :parent-context="this"
      :location="location"
      view-source="tabBilling"
      @toPreStep="toPreStep"
      @refreshBillPayment="refreshBillPaymentH5"
    />
    <!--账单详情-->
    <oversea-bill-detail
      v-if="overseaBillDetail.visible"
      :visible.sync="overseaBillDetail.visible"
      :billing-uuid="overseaBillDetail.billingUuid"
      :create-oversea-charge="createOverseaCharge"
      :show-wht-tax="showWhtTax"
      @applyInvoice="bill=>{toMakeInvoice(bill,()=>{overseaBillDetail.visible=false})}"
      @viewInvoice="invoiceUuids=>{overseaBillDetail.visible=false; $refs.invoice.openInvoiceDetails(invoiceUuids)}"
    />
    <!--开票-->
    <make-invoice-dialog
      ref="invoice"
      view-source="overseaBilling"
      :location="location"
      @reloadData="onCloseCallBackFun"
    />
    <!-- 选择结算对象弹窗 -->
    <settlement-select-dialog :visible.sync="settlementSelectDialog.visible" :title="settlementSelectDialog.title" :accounts="settlementSelectDialog.accounts" :settlements="settlementSelectDialog.settlements" :source="'overseaBilling'" @selectItemWinHandler="selectItemWinHandler" />

    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="job.lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
  </div>
</template>

<script>

import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { Job } from '@/class/model/booking/Job'
import BillDialog from '@/components/Cargo/Act/billDialog'
import agencyShareBillDialog from '@/components/Cargo/Act/agencyShareBillDialog'
import { OverseaBillingBase } from './overseaBillingBase'
import EditAgentBillNoDialog from '@/components/Cargo/Act/editAgentBillNoDialog'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import OverseaBillingDialog from '@/components/Cargo/Act/overseaBillingDialog'
import splitOverseaBillingDialog from '@/components/Cargo/Act/splitOverseaBillingDialog'
import { formatNumberToThousands } from '@/utils'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { recheckBilling, setBillingNo, setBillingsNo, updateBillingState } from '@/api/clearing/billingNative'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import BillPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentDialog'
import newBillPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/newBillPayMentDialog'
import billPaymentDetailForH5 from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/billPaymentDetail'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import overseaBillDetail from '@/components/Cargo/Act/overseaBillDetail'
import makeInvoiceDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceDialog'
import SettlementSelectDialog from '@/components/Cargo/Job/settlementSelectDialog'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow.vue'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { getJobByKeys } from '@/api/booking/job'
import { cache } from '@/utils/cacheManager'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import * as BillingUtils from '@/class/cargo/model/utils/BillingUtils'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { getJobInstructions } from '@/api/sysManage/uiCustom'
import lodash from 'lodash'

export default {
  name: 'OverseaBilling',
  components: {
    BatchCheckingWindow,
    SettlementSelectDialog,
    CargoButtonGroupSlider, OverseaBillingDialog, EditAgentBillNoDialog, BillDialog, agencyShareBillDialog, cargoUpDownResize, cargoTemplateSelectorDialog,
    BillPaymentDialog, newBillPaymentDialog, billPaymentDetailForH5, splitOverseaBillingDialog, overseaBillDetail, makeInvoiceDialog
  },
  props: {
    context: {
      type: Object,
      default: null
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      default: ''
    },
    location: { type: String, required: false },
    enableUiCustom: { type: Boolean, default: false }, // 是否启用UI自定义
    pageType: { type: Number, default: 0 } // UI自定义页签类型
  },
  data() {
    return {
      loading: null,
      masterFlag: false,
      selectedDataList: [],
      up: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          /* onCellFocused: (event) => {
            this.onUpCellFocused(event)
          },*/
          onRowClicked: p => { this.pm.onBillingGridItemClick(p) },
          onRowSelected: p => {
            this.pm.onRowSelected(p)
            this.up.selectedRows = p.api.getSelectedRows()
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: '',
            field: '',
            width: 65,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('FinanceManage.international_billNo'),
            field: 'billingNo',
            width: 150
          },
          {
            headerName: this.$t('FinanceManage.international_agentBillNo'),
            field: 'counterPartyBillingNo',
            width: 150
          },
          {
            headerName: this.$t('FinanceManage.international_revenueAndExpenditureType'),
            field: 'ar',
            width: 150,
            cellRenderer: (params) => {
              return this.isArLabFun(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.international_settleAccountTo'),
            field: 'accountId',
            width: 150,
            cellRenderer: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId')
            }
          },
          {
            headerName: this.$t('FinanceManage.international_settlementAgent'),
            field: 'settlementAgentId',
            width: 150,
            cellRenderer: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId')
            }
          },
          {
            headerName: this.$t('FinanceManage.international_currency'),
            field: 'currency',
            width: 100
          },
          {
            headerName: this.$t('FinanceManage.international_chargeAmount'),
            field: 'amount',
            width: 110,
            cellClass: 'ag-right-aligned-cell',
            cellRenderer: (params) => {
              return ColumnUtils.number2ColumnLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.charge_confirmOrNot'),
            field: 'confirmed',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.booleanLabelFunction(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.international_status'),
            field: 'state',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.billingStateLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.international_billType'),
            field: 'billingType',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.getBillType(params.value)
            }
          },
          {
            headerName: this.$t('Billing.billingJob_confirmDate'),
            field: 'confirmDate',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Carge_BillingConfirmUser'), field: 'confirmUser', colId: 'confirmUser', width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('FinanceManage.international_invoicingStatus'),
            field: 'invoiceState',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.invoiceStateLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.international_writeOffStatus'),
            field: 'realClearingState',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.clearingStateLabFun(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.international_billDtae'),
            field: 'inputDate',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_DueDate'),
            field: 'dueDate',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.international_creator'),
            field: 'inputBy',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('FinanceManage.international_billingGroupNo'),
            field: 'billingGroupNo',
            width: 120
          },
          {
            headerName: this.$t('CargoMsg.Cargo_InvalidOrNot'),
            field: 'revoked',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.booleanLabelFunction(params.value)
            }
          },
          {
            headerName: this.$t('Billing.billing_recheckStatus'), field: 'review', colId: 'review', width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.billingReviewLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('Billing.billing_reviewPeople'),
            field: 'reviewBy',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          }, {
            headerName: this.$t('Billing.billing_reviewDate'),
            field: 'reviewDate',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('Billing.BillSettlementType'),
            field: 'settlementType',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.billSettlementTypeLableFun(params.value)
            }
          }, {
            headerName: this.$t('Billing.ForeignInvoiceTime'),
            field: 'overseaInvoiceDate',
            width: 200,
            hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Billing.InvalidDate'),
            field: 'invalidDate',
            width: 120,
            hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_VoidedBy'), field: 'invalidBy', width: 120, hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            }
          }
        ],
        rowData: [],
        selectedRows: [],
        gridApi: null
      },
      down: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          // 行背景色设置
          getRowStyle: function(params) {
            if (params.node.data.receivable) {
              return { background: '#EFEFEF' }
            } else {
              return { background: '#999999' }
            }
          }
        },
        rowData: [],
        gridApi: null
      },
      settlementSelectDialog: {
        visible: false,
        title: '',
        accounts: [],
        settlements: []
      },
      pm: new OverseaBillingBase(this),
      btnEnable: {
        btnAccountAdd: false,
        btnPayAdd: false,
        btnEdit: false,
        btnDel: false,
        btnView: false,
        ddlBranchId: false,
        btnConfirm: false,
        btnCancelConfirm: false,
        btnRecheck: false,
        btnCancelRecheck: false
      },
      job: new Job().fillDefaultValue().getData(),
      cbShowSelfChanges: false, // 仅显示本委托费用
      cbShowAllBilling: false, // 是否显示所有账单
      specialBillingBranchId: 0, // 默认账单所属分公司
      cbShowInternal: true, // 内结费用
      controllerVisible: {
        cbShowSelfChanges: false,
        showSpecialCharge: false,
        btnPrintAllAgent: false,
        cbShowInternal: false
      },
      permission: {
        btnDel: false,
        btnAutid: false,
        btnEditAgentBillNo: false
      },
      billingFormParams: { // 账单详情页 相关信息数据(除账单以为的数据)
        sourceRate1Enable: true, // 第一行汇率是否可编辑，默认不可编辑
        sourceRate2Enable: true, // 第二行汇率是否可编辑，默认不可编辑
        sourceRate3Enable: true // 第三行汇率是否可编辑，默认不可编辑}
      },
      selectedBilling: null,
      billingList: [],
      chargeList: [],
      billDialog: { // 账单弹出框
        visible: false,
        billingUuid: '',
        isView: false
      },
      agencyShareBillDialog: {
        visible: false
      },
      editAgentBillNoDialog: { // 编辑代理账单编号
        visible: false
      },
      overseaBillingDialog: { // 国外账单详情弹窗
        visible: false,
        currentBillingBranchId: 0,
        billingChargeDetail: [],
        isAddOrEdit: false,
        createBillWay: 0,
        instructionBtns: []
      },
      newOverseaBillingDialog: { // 国外账单详情弹窗
        visible: false,
        currentBillingBranchId: 0,
        billingChargeDetail: [],
        customerDetail: {},
        isAddOrEdit: false
      },
      templateSelectorDialog: {// 模板选择弹窗
        visible: false,
        ctx: null,
        category: 'ANGENT_BILLINGS',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      printCategory: 'BILLING',
      INTERNALBILLING: 'INTERNALBILLING',
      BILLING: 'BILLING',
      printEvent: null, // print callback
      showBillPaymentDialog: false,
      billPaymentDialogUuid: '',
      billPaymentDialogForH5: { // 付款申请-H5 弹窗变量
        visible: false,
        title: this.$t('CargoMsg.Cargo_CreatePaymentRequestChooseFees'),
        source: 'tabBilling',
        uuid: '',
        defaultConditions: {
          exceptKeys: [],
          hasBillPayment: -1,
          hasBilling: -1,
          oversea: -1,
          accountId: 0,
          billingKeys: [] // 账单UUID
        },
        billPaymentDetailProperties: {
          visible: false,
          title: '',
          uuid: '',
          state: -1,
          charges: [],
          chargesDirty: false,
          billPaymentDirty: false,
          inputBy: 0
        }
      },
      overseaBillDetail: { // 账单详情
        visible: false,
        billingUuid: ''
      },
      createOverseaCharge: false, // 是否允许国外费用开票
      makeInvoiceProperties: { // 开票动作传递的参数
        keys: [], // 此处统一传递uuid集合，后续会请求后台，组装树状结构
        isAr: false,
        step: '',
        hedgeKeys: [], // 对冲开票uuid集合
        isHedge: false,
        isSkipInvoiceFrom: false,
        makeInvoiceMethod: 3, // 开票方式:3代表账单
        selectedEntities: []
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null,
        billDataList: [],
        btnConfimKeys: [],
        btnRecheckBillings: []
      },
      billElementDict: {},
      detailElementDict: {},
      billPageSet: { newHide: false, editHide: false }, // 海出-账单页签设置
      instructioinBtns: []
    }
  },
  computed: {
    readonly() {
      return this.action === 'look'
    },
    isEdit() {
      return this.action !== 'look'
    },
    user() {
      return this.context.user || {}
    },
    officeList() {
      return this.context.officeList
    },
    showWhtTax() {
      return this.$store.getters.currentOffice.whtTaxMode && ['RemoteBooking', 'BookingVerify', 'SeaBooking', 'SiBooking', 'AeBooking', 'AiBooking', 'RailwayBooking', 'IeBooking', 'SiPrediction', 'AeBookingVerify', 'AiOrder', 'RailwayVerify', 'financeDetail'].includes(this.viewSource)
    },
    upColumnDefs() {
      let result = [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('FinanceManage.international_billNo'),
          field: 'billingNo',
          width: 150
        },
        {
          headerName: this.$t('FinanceManage.international_agentBillNo'),
          field: 'counterPartyBillingNo',
          width: 150
        },
        {
          headerName: this.$t('FinanceManage.international_revenueAndExpenditureType'),
          field: 'ar',
          width: 150,
          cellRenderer: (params) => {
            return this.isArLabFun(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.international_settleAccountTo'),
          field: 'accountId',
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId')
          }
        },
        {
          headerName: this.$t('FinanceManage.international_settlementAgent'),
          field: 'settlementAgentId',
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId')
          }
        },
        {
          headerName: this.$t('FinanceManage.international_currency'),
          field: 'currency',
          width: 100
        },
        {
          headerName: this.$t('FinanceManage.international_chargeAmount'),
          field: 'amount',
          width: 110,
          cellClass: 'ag-right-aligned-cell',
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_confirmOrNot'),
          field: 'confirmed',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.international_status'),
          field: 'state',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.billingStateLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.international_billType'),
          field: 'billingType',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.getBillType(params.value)
          }
        },
        {
          headerName: this.$t('Billing.billingJob_confirmDate'),
          field: 'confirmDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Carge_BillingConfirmUser'),
          field: 'confirmUser',
          colId: 'confirmUser',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('FinanceManage.international_invoicingStatus'),
          field: 'invoiceState',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.invoiceStateLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.international_writeOffStatus'),
          field: 'realClearingState',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.clearingStateLabFun(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.international_billDtae'),
          field: 'inputDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DueDate'),
          field: 'dueDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.international_creator'),
          field: 'inputBy',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('FinanceManage.international_billingGroupNo'),
          field: 'billingGroupNo',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvalidOrNot'),
          field: 'revoked',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('Billing.billing_recheckStatus'), field: 'review', colId: 'review', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.billingReviewLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('Billing.billing_reviewPeople'),
          field: 'reviewBy',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('Billing.billing_reviewDate'),
          field: 'reviewDate',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('Billing.BillSettlementType'),
          field: 'settlementType',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.billSettlementTypeLableFun(params.value)
          }
        }, {
          headerName: this.$t('Billing.ForeignInvoiceTime'),
          field: 'overseaInvoiceDate',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Billing.InvalidDate'),
          field: 'invalidDate',
          width: 120,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VoidedBy'), field: 'invalidBy', width: 120, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }
      ]
      if (this.showWhtTax) {
        result.push(
          {
            headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
            field: 'whtTaxLocalAmount',
            width: 100,
            valueFormatter: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          }, {
            headerName: this.$t('FinanceManage.charge_notWhtAmount'),
            field: 'notWhtAmount',
            width: 200,
            valueFormatter: (params) => {
              return this.$numeral(params.value).format('0.00')
            }
          })
      }
      if (this.enableUiCustom) {
        result = UICustomUtil.handleColumnLabelAndDisplay(result, this.billElementDict)
      }
      return result
    },
    downColumnDefs() {
      let result = [
        {
          headerName: this.$t('FinanceManage.international_businessNumber'),
          field: 'jobNo',
          width: 120
        },
        {
          headerName: this.$t('FinanceManage.international_revenueOrExpenditure'),
          field: 'receivable',
          width: 100,
          cellRenderer: (params) => {
            return this.arapComboBoxLabelEnFunc(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.international_chargeItem'),
          field: 'chargeItemId',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        {
          headerName: this.$t('FinanceManage.international_currency'),
          field: 'currency',
          width: 100
        },
        {
          headerName: this.$t('FinanceManage.international_taxIncludedPrice'),
          field: 'amount',
          width: 100,
          cellClass: 'ag-right-aligned-cell',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value))
          }
        },
        {
          headerName: this.$t('FinanceManage.international_taxExcludedPrice'),
          field: 'excludingTaxAmount',
          width: 120,
          cellClass: 'ag-right-aligned-cell',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value))
          }
        },
        {
          headerName: this.$t('FinanceManage.international_taxRate'),
          field: 'taxRate',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.international_taxAmount'),
          field: 'taxAmount',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.international_unit'),
          field: 'measure',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('FinanceManage.international_amount'),
          field: 'quantity',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.international_unitPrice'),
          field: 'unitRate',
          width: 110,
          cellClass: 'ag-right-aligned-cell',
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.international_remarks'),
          field: 'remarks',
          width: 100
        },
        {
          headerName: this.$t('FinanceManage.charge_invoiceHeader'),
          field: 'invoiceTitle',
          hide: true,
          width: 100
        }, {
          headerName: this.$t('FinanceManage.international_settlementAgent'),
          field: 'settlementAgentId',
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Business_CustomerRefNo'),
          field: 'jobCustomerRefNo',
          width: 200
        }
      ]
      if (this.showWhtTax) {
        result.push({
          headerName: this.$t('FinanceManage.charge_whtTaxRate'),
          field: 'whtTaxRate',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
          field: 'whtTaxLocalAmount',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        }, {
          headerName: this.$t('FinanceManage.charge_notWhtAmount'),
          field: 'notWhtAmount',
          width: 200,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        })
      }
      if (this.enableUiCustom) {
        result = UICustomUtil.handleColumnLabelAndDisplay(result, this.detailElementDict)
      }
      return result
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      handler() {
        this.loadPageConfig()
        this.loadPageSet()
      }
    }
  },
  methods: {
    loadPageConfig() {
      if (!this.enableUiCustom) {
        return
      }
      this.billElementDict = UICustomUtil.getPageConfig(this.pageType, this.$store.getters.currentOfficeId, undefined, 'OverseaBillInfo').elementDict
      this.detailElementDict = UICustomUtil.getPageConfig(this.pageType, this.$store.getters.currentOfficeId, undefined, 'BillingDetails').elementDict
    },
    loadPageSet() {
      if (!this.enableUiCustom) {
        return
      }
      this.billPageSet = UICustomUtil.getOverseaBillPageSet(this.pageType)
    },
    onUpCellFocused(event) {
      this.pm.onUpCellFocused(event)
    },
    async onShow(row) {
      this.loading = getLoading4Cxt(this)
      try {
        this.masterFlag = row.masterFlag || false
        this.job = row
        // 初始赋值，避免changeJob 后值仍保留上次的值
        this.selectedBilling = null
        this.selectedDataList = []
        this.billingList = []
        this.chargeList = []
        this.pm.refreshGrid() // 刷新表格并清除选中
        await this.pm.initializeHandler()
        await this.pm.commitProperties()
        this.loadInstructionBtns()
        if (this.enableUiCustom) {
          UICustomUtil.handleViewAndWrite(this.pageType, this.billElementDict, row)
          UICustomUtil.handleViewAndWrite(this.pageType, this.detailElementDict, row)
        }
      } finally {
        this.loading.close()
      }
    },
    arapComboBoxLabelEnFunc(value) {
      return value === true ? this.$t('Message.Receivable') : this.$t('Message.Payable')
    },
    // 收支类型
    isArLabFun(value) {
      return value ? 'DEBIT' : 'CREDIT'
    },
    // 编辑对方账单号-保存成功后事件处理
    editAgentBillNoSaveSuccessHandler() {
      this.$message.success(this.$t('Message.SaveSucceed'))
      this.pm.loadBilling()
    },
    // 新增、编辑 国外账单-保存后事件
    onCloseCallBackFun() {
      this.pm.editCloseCallBackFun()
      this.context.reloadCharge = true
    },
    // 代理账单保存后事件
    agentSaveSuccessHandler() {
      this.pm.loadBilling()
      this.context.reloadCharge = true
    },
    // 组装打印参数
    getPrintData() {
      if (!this.up.gridApi || !this.$checkPermission(['button_billTab_overseaBillingPrint'])) {
        this.$message.warning(this.$t('Message.OverseasBillsCanNotBePrinted'))
        return
      }
      const selectList = this.up.gridApi.getSelectedRows()
      if (selectList && selectList.length <= 0 && !this.selectedBilling) {
        this.$message.warning(this.$t('Message.NoSelectedBill'))
        return
      }
      if (!BillingUtils.hasOverseasBillVarifyBillStatus(selectList)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ForeignBillStatusError'))
        return
      }
      // 如果是配置参数只允许打印一个的话：
      if (this.pm.isBulkPrint) {
        this.print()
      } else {
        // 这个分两种情况 勾选 和 选中 优先选中
        if (selectList.length > 1) {
          this.printBillingHandler()
        } else if (selectList.length === 1 || this.selectedBilling) {
          this.print()
        }
      }
      return null
    },
    print() {
      const selectList = this.up.gridApi.getSelectedRows()
      // 这边只支持单个打印 优先选中
      let bill = null
      if (selectList.length > 1) {
        return
      } else if (this.selectedBilling) {
        bill = this.selectedBilling
      } else if (selectList.length === 1) {
        bill = selectList[0]
        this.pm.setGridSelect(bill)
      }
      if (bill) {
        // TemplateSelectorWin.getInstance().showThisWin(job, printCategory, params, this, prePrintFun);
        const params = {}
        params.BILLINGNO = bill.uuid
        if (this.job) {
          params.jobuuid = this.job.uuid
        }
        params.category = this.printCategory
        params.fileAliasName = bill.billingNo
        params.BILLING_UUID = bill.uuid
        params.printSource = DocumentConstants.BUSINESS_BILL_PRINT.code
        switch (this.job.lob) {
          case 'SE':
            params.ctx = new SeaExportJob(this.job)
            break
          case 'SI':
            params.ctx = new SeaImportJob(this.job)
            params.category = 'DEBITNOTE_SI'
            break
          case 'AE':
            params.ctx = new AirExportJob(this.job)
            params.category = 'AEBILLING'
            break
          case 'AI':
            params.ctx = new AirImportJob(this.job)
            params.category = 'DEBITNOTE_AI'
            break
          case 'RE':
          case 'RI':
            params.ctx = new RailwayExportJob(this.job)
            break
        }
        // 组装回调函数
        params.selectedBilling = this.selectedBilling
        this.templateSelectorDialog.ctx = Object.prototype.hasOwnProperty.call(params, 'ctx') ? params.ctx : null
        if (Object.prototype.hasOwnProperty.call(params, 'ctx')) delete params.ctx
        this.templateSelectorDialog.category = params.category
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        this.prePrintCallback = this.prePrintFun
        this.templateSelectorDialog.visible = true
      }
    },
    prePrintFun(event) {
      this.printEvent = event
      if (!this.selectedBilling && event && event.parameter && event.parameter.selectedBilling) {
        this.selectedBilling = event.parameter.selectedBilling
      }
      if (event.action === 'print' || event.action === 'save') {
        // 加载当前选中账单的费用
        if (!this.selectedBilling) {
          this.pm.onBillingGridItemClick(this.selectedBilling)
        }
        this.loadCharge2Handler()
      } else {
        // TemplateSelectorWin.getInstance().hideThisWin(event);
        this.templateSelectorDialog.visible = false
      }
    },
    loadCharge2Handler() {
      // 用于已经有账单号， 状态处于未打印场景
      if (this.selectedBilling.billingNo && this.selectedBilling.state === -1) {
        // 后端修改状态
        updateBillingState({ billKey: this.selectedBilling.uuid, state: 2, isPrint: true }).then(res => {
          // 加载费用后赋值给bill 费用List属性上
          Object.assign(this.selectedBilling, res.data)
          this.doPrint(this.selectedBilling, this.printEvent)
          this.pm.onBillingGridItemClick(this.selectedBilling)
        }).catch(() => {
          this.pm.onBillingGridItemClick(this.selectedBilling)
        })
      } else if (!this.selectedBilling.billingNo) {
        // 后端修改账单号
        setBillingNo({ billKey: this.selectedBilling.uuid, location: this.location, isPrint: true }).then(res => {
          // 加载费用后赋值给bill 费用List属性上
          Object.assign(this.selectedBilling, res.data)
          this.doPrint(this.selectedBilling, this.printEvent)
          this.pm.onBillingGridItemClick(this.selectedBilling)
        }).catch(() => {
          this.pm.onBillingGridItemClick(this.selectedBilling)
        })
      } else {
        this.doPrint(this.selectedBilling, this.printEvent)
        this.pm.onBillingGridItemClick(this.selectedBilling)
      }
    },
    // 账单打印使用
    doPrint(billing, printEvent) {
      if (!printEvent) return
      if (printEvent.template && StimulSoftUtil.isOpenStiReport(printEvent.template)) {
        this.$nextTick(async() => {
          const res = await this.$refs['templateDialog'].printFileV2(printEvent)
          if (printEvent.exportType) {
            this.$refs['templateDialog'].handlePrintResult(res)
          }
        })
      } else {
        const printType = printEvent.parameter.printType
        printEvent.parameter.fileAliasName = billing.billingNo
        if (printType === PrintTemplateManager.EMAIL) {
          // FlexGlobals.topLevelApplication.appView.selectedChild.saveSendEmailFile()
          this.$nextTick(() => {
            this.$refs['templateDialog'].sendEmailTriggerEventHandler(printEvent)
          })
        } else if (printType === PrintTemplateManager.FAX) {
          // 传真有说不加了【无需验证】
          // FlexGlobals.topLevelApplication.appView.selectedChild.saveSendFaxFile()
          PrintTemplateManager.fax(printEvent.template, PrintTemplateManager.FORMAT_PDF, printEvent.parameter)
        } else {
          PrintTemplateManager.print(printEvent.template, printEvent.documentType, printEvent.format, printEvent.parameter, printEvent.action === 'print')
        }
      }
      this.pm.refreshGrid() // 刷新表格并清除选中
    },
    // 打印账单
    printBillingHandler() {
      const billings = this.up.gridApi.getSelectedRows()
      if (billings.length <= 0) {
        this.$message.info('请选择账单.')
        return
      }

      const keyList = Array.from(billings, p => p.uuid)
      const params = {}
      params.BILLING_UUID_LIST = keyList
      params.BILLING_UUID = params.BILLING_UUID_LIST
      params.printSource = DocumentConstants.BUSINESS_BILL_PRINT.code
      // CARGO-32068 天津中船14475：批量打印账单，无法将生成的文件至文件历史中
      if (this.job) {
        params.uploadJobFileHistoryParam = { jobNo: this.job.jobNo }
      }
      const billing = billings[0]
      if (billing.billingType === BillingConstants.BILLING_TYPE_INTERNAL.code) {
        // CARGO-6000，圣世特：V2模板，国内账单另存文件，文件名需要由模板名称+账单号组成
        if (billings.length === 1) {
          params.billingNo = billing.billingNo
          if (billing.jobUuid && this.job) {
            params.jobNo = this.job.jobNo
          }
        }
        params.category = this.INTERNALBILLING
        this.prePrintCallback = null
      } else {
        if (this.job && this.job.lob === 'AI') {
          params.category = 'DEBITNOTE_AI'
        } else {
          params.category = this.BILLING
        }
        this.prePrintCallback = this.prePrint
      }
      this.$logger.log('===printBillingHandler=params===', params)
      this.templateSelectorDialog.ctx = null
      this.templateSelectorDialog.category = params.category
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    },
    // 打印动作
    prePrint(printEvent) {
      const billings = this.up.gridApi.getSelectedRows()
      let needSet = false
      for (const billing of billings) {
        if (!billing.billingNo) {
          needSet = true
          break
        }
      }
      const billingMap = new Map()
      // CARGO-32319 批量打印国外账单，提示系统错误
      const billingList = []
      const printDate = ColumnUtils.dateTimeLabelFunc(new Date())
      for (const billing of billings) {
        if (billingMap.has(billing.uuid)) continue
        billingMap.set(billing.uuid, billing)
        if (!billing.overseaInvoiceDate) {
          billing.overseaInvoiceDate = printDate
        }
        billing.isPrint = true
        billingList.push({ ...billing, charge: null })
      }
      if (needSet) {
        setBillingsNo(billingList).then(res => {
          // 加载费用后赋值给bill 费用List属性上
          const bills = res.data
          if (bills && bills.length > 0) {
            for (const billing of bills) {
              delete billing.charge
              if (billingMap.has(billing.uuid) && billingMap.get(billing.uuid)) {
                const oldBill = billingMap.get(billing.uuid)
                Object.assign(oldBill, billing)
              }
            }
          }
          this.pm.onBillingGridItemClick(this.selectedBilling)
          this.doPrint(this.selectedBilling, printEvent)
        })
      } else {
        this.doPrint(this.selectedBilling, printEvent)
      }
    },
    /**
   * 申请付款
   */
    async applyForPayment() {
      const chooseRows = this.up.gridApi.getSelectedRows()
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      if (chooseRows[0].branchId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      const isSameAccount = ClearingUtils.isSameAccount(chooseRows)
      const isSameSettlementAgent = isSameAccount ? false : ClearingUtils.isSameSettlementAgent(chooseRows)
      if (!isSameAccount && !isSameSettlementAgent) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SettlingPartyOrSettlementAgentInconsistent'))
        return
      }
      if (!ClearingUtils.createBillPaymentCheckBillingState(chooseRows)) return
      const charges = await ClearingUtils.createBillPaymentByBilling(chooseRows, -1, 'InternalBill')
      if (charges && charges.length > 0) {
        const notPaymentBillingKeys = []
        for (const charge of charges) {
          if (!charge.billPaymentUuid) {
            notPaymentBillingKeys.push(charge.chargeBillUuid)
          }
        }
        if (notPaymentBillingKeys.length === 0) {
          this.billPaymentDialogUuid = charges[0].billPaymentUuid
          this.showBillPaymentDialog = true
        } else {
          this.billPaymentDialogForH5.defaultConditions.billingKeys = notPaymentBillingKeys
          this.billPaymentDialogForH5.visible = true
        }
      }
    },
    // 选择费用创建付款申请-H5 下一步回调
    async nextCreateBillPaymentCallback(charges) {
      if (charges && charges.length > 0) {
      // 隐藏创建弹窗
        this.billPaymentDialogForH5.visible = false
        // 展示详情弹窗
        this.showBillPaymentDialog = true
        this.$refs.billPayment.initBillPayment(charges)
      }
    },
    // 创建付款申请-H5第二步回退至第一步
    toPreStep() {
      this.billPaymentDialogForH5.billPaymentDetailProperties.visible = false
      this.billPaymentDialogForH5.visible = true
    },
    // 刷新界面
    refreshBillPaymentH5(billPayment) {
      this.billPaymentDialogForH5.billPaymentDetailProperties.visible = false
      this.billPaymentDialogForH5.billPaymentDetailProperties.uuid = billPayment ? billPayment.uuid : ''
      this.billPaymentDialogForH5.billPaymentDetailProperties.visible = true
      this.billPaymentDialogForH5.billPaymentDetailProperties.state = billPayment ? billPayment.state : -1
      this.billPaymentDialogForH5.billPaymentDetailProperties.inputBy = billPayment ? billPayment.inputBy : 0
      this.billPaymentDialogForH5.billPaymentDetailProperties.title = this.$t('CargoMsg.Cargo_ViewPaymentRequest')
      this.$refs.billPaymentDetailForH5.reloadData()
    },
    // 查看
    viewClickHandler() {
      const bill = this.selectedBilling
      if (!bill) {
        return
      }
      this.overseaBillDetail.billingUuid = bill.uuid
      this.overseaBillDetail.visible = true
    },
    // 开票
    async toMakeInvoice(bill, closeBillDialogFunc) {
      if (bill.state === 0) {
        await this.$confirm(this.$t('Invoice.existUnconfirmedStatus'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        })
      }
      if (bill.branchId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      closeBillDialogFunc()
      const selectedBill = this.normalizeBillInvoiceTypeByTaxRate(bill)
      this.makeInvoiceProperties.isAr = bill.ar
      this.makeInvoiceProperties.keys = [bill.uuid]
      this.makeInvoiceProperties.step = 'step1'
      this.makeInvoiceProperties.selectedEntities = [selectedBill]
      await this.$refs.invoice.makeInvoice({ ...this.makeInvoiceProperties })
    },
    normalizeBillInvoiceTypeByTaxRate(bill) {
      if (!bill || !bill.ar) {
        return bill
      }
      const rawTaxRate = bill.taxRate !== undefined && bill.taxRate !== null && bill.taxRate !== ''
        ? bill.taxRate
        : bill.chargeTaxRate
      if (rawTaxRate === undefined || rawTaxRate === null || rawTaxRate === '') {
        return bill
      }
      const taxRateValue = Number(String(rawTaxRate).replace('%', '').replace(/[^\d.-]/g, '').trim())
      if (Number.isNaN(taxRateValue)) {
        return bill
      }
      return {
        ...bill,
        invoiceType: taxRateValue > 0 ? 6 : 7
      }
    },
    // 选择结算单位后事件处理
    selectItemWinHandler(accountId, createBillWay) {
      this.pm.openBillingWindow(accountId, createBillWay)
    },
    // 取消事件
    cancel() {
      this.showBillPaymentDialog = false
      this.billPaymentDialogUuid = ''
    },
    // PILL-80 GP率预警加相关校验 该方法为在原本的处理逻辑上添加一层规则校验 该按钮的验证规则节点应该固定只为 CheckRuleConstants.NODE_AR_SURE 或者 CheckRuleConstants.NODE_AP_SURE
    async checkRuleAndConfirm(confirm) {
      // 判断是否开启验证规则
      const useCheckRule = Number(this.context.config.get('useCheckRule')) === 1
      if (useCheckRule) {
        // 查询该分公司配置了是否配置了 CheckRuleConstants.NODE_AR_SURE 或者 CheckRuleConstants.NODE_AP_SURE 节点
        let hasArNode
        let hasApNode
        if (confirm) {
          hasArNode = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_AR_SURE.code, this.$store.getters.currentOfficeId)
          hasApNode = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_AP_SURE.code, this.$store.getters.currentOfficeId)
        } else {
          hasArNode = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_AR_RECHECK.code, this.$store.getters.currentOfficeId)
          hasApNode = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_AP_RECHECK.code, this.$store.getters.currentOfficeId)
        }
        // 使用reduce方法将每个对象的chargeList合并到一个新的数组中
        let combinedChargeList = []
        if (this.selectedDataList && this.selectedDataList.length > 0) {
          for (const billing of this.selectedDataList) {
            // 国外账单
            if (billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code && billing.charge && billing.charge.length > 0) {
              combinedChargeList = combinedChargeList.concat(billing.charge)
            }
            // 代理分成账单
            if (billing.billingType === BillingConstants.BILLING_TYPE_AGENT.code && billing.agentSharedCharge && billing.agentSharedCharge.length > 0) {
              combinedChargeList = combinedChargeList.concat(billing.agentSharedCharge)
            }
          }
        }
        // 判断是否全部为应收
        const allAr = combinedChargeList.every(item => item.receivable === true)
        // 判断是否全部为应付
        const allAp = combinedChargeList.every(item => item.receivable === false)
        //  说明该分公司配置了 CheckRuleConstants.NODE_AR_SURE 或者 CheckRuleConstants.NODE_AP_SURE 节点 那么用户勾选的数据就只能全部为AR或者AP
        if ((hasArNode || hasApNode) && !(allAr || allAp)) {
          this.$message.warning(this.$t('CargoMsg.CheckArApDisparity'))
        } else {
          // 开启了验证规则 就判断当前所选的数据是否全部为应收或者全部为应付
          if (this.nodeArApHandle(hasArNode, hasApNode, allAr, allAp)) {
            // 定义回调方法
            let callBack = null
            if (confirm) {
              callBack = this.invokePmConfirmHandle || null
            } else {
              callBack = this.invokePmRecheckHandle || null
            }
            // 定义节点
            this.batchCheckingWindow.checkNode = allAr ? confirm ? CheckRuleConstants.NODE_AR_SURE.code : CheckRuleConstants.NODE_AR_RECHECK.code : confirm ? CheckRuleConstants.NODE_AP_SURE.code : CheckRuleConstants.NODE_AP_RECHECK.code
            // 取出该账单的费用信息，根据费用的jobUuid查询数据
            const jobUuids = combinedChargeList.map(item => item.jobUuid)
            // 根据jobUuid查询job的数据返回
            const jobList = await getJobByKeys(jobUuids).then(res => res.data)
            this.batchCheckingWindow.jobs = jobList
            this.batchCheckingWindow.callBack = callBack
            this.batchCheckingWindow.visible = true
          } else {
            // 分公司开启了验证规则配置, 但是未配置该验证节点 或者验证节点 继续走原本逻辑
            if (confirm) {
              this.invokePmConfirmHandle()
            } else {
              this.invokePmRecheckHandle()
            }
          }
        }
      } else {
        // 未开启验证规则就走原本的处理逻辑
        if (confirm) {
          this.invokePmConfirmHandle()
        } else {
          this.invokePmRecheckHandle()
        }
      }
    },
    nodeArApHandle(arNode, apNode, allAr, allAp) {
      const result = false
      if (arNode && allAr) {
        return true
      }
      if (apNode && allAp) {
        return true
      }
      return result
    },
    invokePmConfirmHandle() {
      this.pm.btnConfirmHandle(this.btnConfimKeys)
    },
    invokePmRecheckHandle() {
      this.pm.btnRecheckHandle(this.btnRecheckBillings)
    },
    // 确认
    btnConfrimClickHandle() {
      const bill = this.selectedBilling
      const chooseRows = this.up.gridApi.getSelectedRows()
      this.btnConfimKeys = []
      for (let i = 0; i < chooseRows.length; i++) {
        const billing = chooseRows[i]
        if (billing.revoked) {
          this.$message.warning(this.$t('queryJob.InvalidBillCannotConfirm'))
          return
        }
        const state = billing.state
        if ((state === Number(BillingConstants.BILLING_NORMAL.code) || !billing.confirmed) && !billing.billingGroupUuid) {
          this.btnConfimKeys.push({ 'key': billing.uuid, 'version': billing.version })
        }
      }
      if (this.btnConfimKeys.length === 0 && !bill) {
        this.$message.warning(this.$t('act.billing.noConfirmBill'))
        return
      }
      if (this.btnConfimKeys.length === 0) {
        const state = bill.state
        if ((state === Number(BillingConstants.BILLING_NORMAL.code) || !bill.confirmed) && !bill.billingGroupUuid) {
          this.btnConfimKeys.push({ 'key': bill.uuid, 'version': bill.version })
        } else {
          this.$message.warning(this.$t('act.billing.noConfirmBill'))
          return
        }
      }
      this.$confirm(this.$t('act.billing.batchConfirmBill', [this.btnConfimKeys.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        return this.checkRuleAndConfirm(true)
      }).catch(() => {
      })
    },
    // 复核
    btnRecheckClickHandle() {
      const chooseRows = this.up.gridApi.getSelectedRows()
      const billing = this.selectedBilling
      this.btnRecheckBillings = []
      if (chooseRows && chooseRows.length !== 0) {
        this.btnRecheckBillings = [...chooseRows]
      } else if (billing) {
        this.btnRecheckBillings.push(billing)
      }
      if (this.btnRecheckBillings.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      this.checkRuleAndConfirm(false)
    },
    // 加载指令按钮
    async loadInstructionBtns() {
      const useHqSet = UICustomUtil.getUseHqSet(UICustomConstants.SEA_BOOKING_OVERSEA_BILL, this.$store.getters.currentOfficeId)
      const res = await getJobInstructions({
        pageType: UICustomConstants.SEA_BOOKING_OVERSEA_BILL,
        branchId: this.$store.getters.currentOfficeId,
        useHqSet,
        jobKey: this.job.uuid,
        lob: this.job.lob
      })
      this.instructioinBtns = res.data
    },
    async onInstructionClick(data) {
      if (data.platformInstructionRuleCode === 'overseaBillEdit') {
        const subInstructionBtns = []
        if (data.instructionParamJson.editType) {
          const arr = data.instructionParamJson.editType.split(',')
          for (const item of arr) {
            const newInstruction = lodash.cloneDeep(data)
            newInstruction.instructionParamJson.editType = item
            subInstructionBtns.push(newInstruction)
          }
        } else {
          subInstructionBtns.push(data)
        }
        this.pm.onEditClickEvent(subInstructionBtns)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.oversea-billing::v-deep {
  .el-dialog.main-content {
    height: unset;
  }
}
</style>>
